import {openWhatsApp} from '../../utils/whatsapp'

const kpis = [
  {
    cls: "amber kpi-float-1",
    label: "Dead Cash Blocked",
    value: "₹18.4L",
    sub: "Tied up in unsold stock",
    trend: "⚠ 89 idle products",
    trendCls: "warn",
  },
  {
    cls: "red kpi-float-2",
    label: "Slow Movers",
    value: "142 SKUs",
    sub: "< 2 units sold / month",
    trend: "↑ 23 worsening",
    trendCls: "danger",
  },
  {
    cls: "blue kpi-float-3",
    label: "Avg Stock Cover",
    value: "67 days",
    sub: "Across all categories",
    trend: "← Ideal is 30–45 days",
    trendCls: "warn",
  },
  {
    cls: "orange kpi-float-4",
    label: "Stop Buying List",
    value: "23 Products",
    sub: "High risk of dead stock",
    trend: "Action needed now",
    trendCls: "danger",
  },
];


export default function Hero() {
  return (
    <section className="sm-hero" id="hero">
      <div className="sm-hero-grid">
        <div>
          <div className="sm-hero-tag">
            <span className="sm-hero-tag-dot" />
            Inventory Intelligence for Retail
          </div>

          <h1 className="sm-hero-h1">
            Your cash is stuck in
            <br />
            <em>inventory that won't sell.</em>
          </h1>

          <p className="sm-hero-sub">
            Stock Move analyses your sales and inventory data to show exactly
            what's dead, what's slowing down, and what to stop buying — so you
            can recover blocked cash fast.
          </p>

          <div className="sm-hero-ctas">
            <button onClick={() => openWhatsApp()} href="#cta" className="sm-btn-primary">
              Get Free Inventory Audit →
            </button>
            <a href="#how-it-works" className="sm-btn-secondary">
              See How It Works
            </a>
          </div>

          <p className="sm-hero-trust">
            No POS required. <span>Upload a CSV and get insights in minutes.</span>
          </p>
        </div>

        <div className="sm-kpi-grid">
          {kpis.map((kpi, index) => (
            <div key={index} className={`sm-kpi-card ${kpi.cls}`}>
              <div className="sm-kpi-label">{kpi.label}</div>
              <div className="sm-kpi-value">{kpi.value}</div>
              <div className="sm-kpi-sub">{kpi.sub}</div>
              <div className={`sm-kpi-trend ${kpi.trendCls}`}>{kpi.trend}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}